export default __webpack_public_path__ + "static/media/ojos-pestanas-pronunciadas-marron.73fef083.png";